import * as React from "react";

export const SettingsButtonsContainer = ({ children, style }: { children: React.ReactNode, style?: React.CSSProperties }) => (
    <div style={{ borderRadius: 10, boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.05)", ...style }}>
        {children}
    </div>
);


// WEBPACK FOOTER //
// ./src/components/loginManagement/components/SettingsButtonsContainer.tsx